import axios from "axios-jsonp-pro";
import { mapGetters } from "vuex";

const PRO_IP_API_KEY = "AmUN9xAaQALVYu6";
const GDPR_COOKIE_NAME = "cookieconsent_status";
const GDPR_COOKIE_DOMAIN = ".yourdictionary.com";
const GDPR_COUNTRIES = [
    "AT",
    "BE",
    "BG",
    "HR",
    "CZ",
    "CY",
    "DK",
    "EE",
    "FI",
    "FR",
    "DE",
    "EL",
    "HU",
    "IE",
    "IT",
    "LV",
    "LT",
    "LU",
    "MT",
    "NL",
    "PL",
    "PT",
    "SK",
    "SI",
    "ES",
    "SE",
    "GB",
    "UK"
];

export default {
    name: "GDPRNotice",
    data() {
        return {
            showGDPRNotice: false,
            policyLink: ""
        };
    },
    methods: {
        allowCookies() {
            this.showGDPRNotice = false;
            this.$cookies.set(
                GDPR_COOKIE_NAME,
                +new Date(),
                "4m",
                "/",
                GDPR_COOKIE_DOMAIN
            );
        }
    },
    computed: {
        ...mapGetters(["currentLanguage"])
    },
    mounted() {
        if (
            typeof window.__PRERENDER_INJECTED === "undefined" &&
            this.$cookies.get(GDPR_COOKIE_NAME) == null
        ) {
            axios
                .jsonp(`https://pro.ip-api.com/json/?key=${PRO_IP_API_KEY}`)
                .then(response => {
                    if (
                        typeof response === "object" &&
                        typeof response.countryCode !== "undefined" &&
                        GDPR_COUNTRIES.includes(response.countryCode)
                    ) {
                        this.showGDPRNotice = true;
                    }
                });
        }

        if (this.currentLanguage === "es") {
            this.policyLink =
                "https://es.yourdictionary.com/politica-de-cookies/";
        } else {
            this.policyLink =
                "https://www.yourdictionary.com/about/cookie.html";
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/GDPRNotice/GDPRNotice.js